const getGiphyApiKey = () => '4wcMikyZVyU7P0S60Tep4MuV1YNJnIvF';

export default getGiphyApiKey;



// WEBPACK FOOTER //
// src/utils/giphy/getGiphyApiKey.js